<!-- 聊天记录 -->
<template>
    <div class="common_chat-wrapper">
        <div class="common_chat-inner">
            <!-- 聊天记录 -->
            <div v-if="chatLoaded" class="common_chat-main" id="common_chat_main" ref="common_chat_main">
                <div class="common_chat-main-content">
                    <div class="inner">
                        <!-- {{ historyDataList }} -->
                          <!-- 历史消息 -->
                          <div style="width: 100%;">
                                <span
                                v-if="total!=0&&total==20"
                                @click="loadMoreMessages"
                                style="text-align: center; margin: 0 auto; margin-top: 5px; border-bottom: 1px solid #2295FF; color: #2295FF; cursor: pointer; display: flex; justify-content: center;width: 100px;">
                                {{ $t('common.loadMoreHistory') }}
                            </span>
                            <span v-else-if="total==0&&page!=1" style="text-align: center; margin: 0 auto; margin-top: 5px; color: #888;display: flex;justify-content: center;">
                                {{ $t('common.noMoreHistory') }}
                            </span>
                          </div>
                          <div>
                                <div v-for="(item ,index) in historyDataList" :key="index" style="margin-top: 10px;">
                                <!-- 系统消息 -->
                                <div  v-if="item.contentType==2"  class="item sys">
                                        <!-- 1)文本类型 -->
                                        <div class="text-content">
                                            <p > {{item.content}}</p>
                                        </div>
                                </div>
                                <div v-if="item.contentType==3"  class="evaluation">
                                    <div class="evaluation_title " >
                                        {{item.content}}
                                    </div>
                                    <!-- &&item.messageExpand.evaluationStatus==0 -->
                                    <div class="evaluation_easy" v-if="item.messageExpand.evaluationType==0">
                                        <el-button type="primary" size="mini" class="send-btn"  :class="chatInfoEn.state" @click="sendRate(item,0)" style="margin-top: 5px;border-radius: 4px;" :disabled="item.messageExpand.evaluationStatus==1">{{ $t('common.evaluation') }}</el-button>
                                    </div>
                                </div>
                                <!-- 客户、客服 -->
                                <div v-if="item.contentType==0"  class="item" :class="{ sender: item.role == oprRoleName, receiver: item.role != oprRoleName }">
                                    <div class="info-wrapper" :class="item.state">
                                        <div style="display: flex;" :class="{ quotesenderNewTwo: item.role == oprRoleName, quotereceiverNewTwo: item.role != oprRoleName }">
                                            <!-- 头像 -->
                                            <div class="avatar-wrapper" v-if="item.role!=oprRoleName">
                                                <img class="kf-img" src="@/assets/im_server_avatar1.png" />
                                            </div>
                                            <!-- 1)文本类型 -->
                                            <div v-if="item.contentType==0" class="item-content common_chat_emoji-wrapper-global">
                                            <!-- <div style="position: relative;height: 100%;width: 100%;"> -->
                                                <!-- <img src="@/assets/fail.png" v-if="item.isSuccess==false" alt="" style="position: absolute;left: -20px;top: 45px;width: 16px;"> -->
                                                <p class="time" ><span v-if="item.role!=oprRoleName" style="margin-right: 5px;">{{item.fromName}}</span> {{ $ak.Utils.formatTimestamp(item.timestamp) }}</p>
                                                <div style="position: relative;display: inline-block;" :class="{ quotesenderNew: item.role == oprRoleName, quotereceiverNew: item.role != oprRoleName }">
                                                    <div class="text" v-html="getqqemojiEmoji(item.content)"></div>
                                                    <span  class="quote " :class="{ quotesender: item.role == oprRoleName, quotereceiver: item.role != oprRoleName }" @click="quote(item)">{{ $t('common.quote') }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="referenceContent common_chat_emoji-wrapper-global" :class="{ quotesenderNews: item.role == oprRoleName, quotereceiverNews: item.role != oprRoleName }"  v-if="item.referenceContent&&Object.keys(item.referenceContent).length > 0&&item.referenceContent.content&&item.referenceContent.contentType==0" v-html="getqqemojiEmoji(item.referenceContent.content)"></div>
                                        <div class="referenceContent" :class="{ quotesenderNews: item.role == oprRoleName, quotereceiverNews: item.role != oprRoleName }"  v-if="item.referenceContent&&Object.keys(item.referenceContent).length > 0&&item.referenceContent.content&&item.referenceContent.contentType==4" ><img :src="item.referenceContent.content" alt="" style="max-width: 100px;cursor: pointer;" @click="imgViewDialog_show(item)"></div>
                                        <!-- </div> -->
                                        <!-- <div v-if="item.contentType==0" class="item-content common_chat_emoji-wrapper-global">
                                            <img src="@/assets/fail.png" v-if="item.isSuccess==false" alt="" style="position: absolute;left: -20px;top: 45px;width: 16px;">
                                            <p class="time" >{{ $ak.Utils.formatTimestamp(item.timestamp) }}</p>
                                            <p class="text" v-html="getqqemojiEmoji(item.content)"></p>
                                        </div> -->
                                    </div>
                                </div>
                                <!-- <div v-if="item.contentType==5"  class="item" :class="{ sender: item.role == oprRoleName, receiver: item.role != oprRoleName }">
                                    <div class="info-wrapper" :class="item.state">
                                        <div style="display: flex;" :class="{ quotesenderNewTwo: item.role == oprRoleName, quotereceiverNewTwo: item.role != oprRoleName }">
                                            <div class="avatar-wrapper" v-if="item.role!=oprRoleName">
                                                <img class="kf-img" src="@/assets/im_server_avatar1.png" />
                                            </div>
                                            <div v-if="item.contentType==5" class="item-content common_chat_emoji-wrapper-global">
                                                <p class="time" ><span v-if="item.role!=oprRoleName" style="margin-right: 5px;">{{item.fromName}}</span> {{ $ak.Utils.formatTimestamp(item.timestamp) }}</p>
                                                <div style="position: relative;display: inline-block;" :class="{ quotesenderNew: item.role == oprRoleName, quotereceiverNew: item.role != oprRoleName }">
                                                    <a v-if="item.messageExpand" :href="item.messageExpand.order_url" target="_blank"> <div class="text text_url" v-html="getqqemojiEmoji(item.messageContent)"></div></a>
                                                    <span  class="quote " :class="{ quotesender: item.role == oprRoleName, quotereceiver: item.role != oprRoleName }" @click="quote(item)">{{ $t('common.quote') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="referenceContent common_chat_emoji-wrapper-global" :class="{ quotesenderNews: item.role == oprRoleName, quotereceiverNews: item.role != oprRoleName }"  v-if="item.referenceContent&&Object.keys(item.referenceContent).length > 0&&item.referenceContent.content&&item.referenceContent.contentType==0" v-html="getqqemojiEmoji(item.referenceContent.content)"></div>
                                        <div class="referenceContent" :class="{ quotesenderNews: item.role == oprRoleName, quotereceiverNews: item.role != oprRoleName }"  v-if="item.referenceContent&&Object.keys(item.referenceContent).length > 0&&item.referenceContent.content&&item.referenceContent.contentType==4" ><img :src="item.referenceContent.content" alt="" style="max-width: 100px;cursor: pointer;" @click="imgViewDialog_show(item)"></div>
                                    </div>
                                </div> -->
                                <div v-if="item.contentType==4"  class="item" :class="{ sender: item.role == oprRoleName, receiver: item.role != oprRoleName }">
                                    <div class="info-wrapper" :class="item.state">
                                        <div style="display: flex;" :class="{ quotesenderNewTwo: item.role == oprRoleName, quotereceiverNewTwo: item.role != oprRoleName }">
                                            <!-- 头像 -->
                                            <div class="avatar-wrapper" v-if="item.role!=oprRoleName">
                                                <img class="kf-img" src="@/assets/im_server_avatar1.png" />
                                            </div>
                                            <!-- 1)文本类型 -->
                                            <div v-if="item.contentType==4" class="item-content common_chat_emoji-wrapper-global">
                                            <!-- <div style="position: relative;height: 100%;width: 100%;"> -->
                                                <!-- <img src="@/assets/fail.png" v-if="item.isSuccess==false" alt="" style="position: absolute;left: -20px;top: 45px;width: 16px;"> -->
                                                <p class="time" ><span v-if="item.role!=oprRoleName" style="margin-right: 5px;">{{item.fromName}}</span> {{ $ak.Utils.formatTimestamp(item.timestamp) }}</p>
                                                <div style="position: relative;display: inline-block;" :class="{ quotesenderNew: item.role == oprRoleName, quotereceiverNew: item.role != oprRoleName }">
                                                    <div class="" > <img :src="item.content" alt="" style="max-width: 250px;cursor: pointer;" @click="imgViewDialog_show(item)"></div>
                                                    <span  class="quote " :class="{ quotesender: item.role == oprRoleName, quotereceiver: item.role != oprRoleName }" @click="quote(item)">{{ $t('common.quote') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="referenceContent common_chat_emoji-wrapper-global" :class="{ quotesenderNews: item.role == oprRoleName, quotereceiverNews: item.role != oprRoleName }"  v-if="item.referenceContent&&Object.keys(item.referenceContent).length > 0&&item.referenceContent.content&&item.referenceContent.contentType==0" v-html="getqqemojiEmoji(item.referenceContent.content)"></div>
                                        <div class="referenceContent" :class="{ quotesenderNews: item.role == oprRoleName, quotereceiverNews: item.role != oprRoleName }"  v-if="item.referenceContent&&Object.keys(item.referenceContent).length > 0&&item.referenceContent.content&&item.referenceContent.contentType==4" ><img :src="item.referenceContent.content" alt=""  style="max-width: 100px;cursor: pointer;" @click="imgViewDialog_show(item)"></div>
                                        <!-- </div> -->
                                        <!-- <div v-if="item.contentType==0" class="item-content common_chat_emoji-wrapper-global">
                                            <img src="@/assets/fail.png" v-if="item.isSuccess==false" alt="" style="position: absolute;left: -20px;top: 45px;width: 16px;">
                                            <p class="time" >{{ $ak.Utils.formatTimestamp(item.timestamp) }}</p>
                                            <p class="text" v-html="getqqemojiEmoji(item.content)"></p>
                                        </div> -->
                                    </div>
                                </div>
                        </div>
                        <span v-if="historyDataList.length!=0" style="color: #aaa;width: 100%;display: block;text-align: center;margin-top: 10px;">{{ $t('common.historyEnd') }}</span>
                          </div>
                          <!-- {{ chatInfoEn.msgList }} -->
                        <div v-for="(item ,index) in chatInfoEn.msgList" :key="index" style="margin-top: 10px;">

                            <!-- 系统消息 -->
                            <div  v-if="item.contentType==2"  class="item sys">
                                    <!-- 1)文本类型 -->
                                    <div class="text-content">
                                        <p class="text"> {{item.content}}</p>
                                    </div>
                            </div>
                            <div v-if="assignFail==true" class="receiver item">
                                <div class="info-wrapper " >
                                    <div class="avatar-wrapper" >
                                            <img class="kf-img" src="@/assets/im_server_avatar1.png" />
                                        </div>
                                        <!-- 1)文本类型 -->
                                        <div class="item-content common_chat_emoji-wrapper-global">
                                            <p class="time" >{{ $t('common.system') }}</p>
                                            <p class="text">{{ $t('common.assignFailMsg') }}</p>
                                    </div>
                                </div>
                            </div>
                            <!-- v-if="rateWord==true" -->
                            <div v-if="item.contentType==3"  class="evaluation">
                                <div class="evaluation_title " >
                                    {{item.content}}
                                </div>
                                <div class="evaluation_easy" v-if="item.contentExpand.evaluationType==0">
                                    <el-button type="primary" size="mini" class="send-btn"  :class="chatInfoEn.state" @click="sendRate(item,1)" style="margin-top: 5px;border-radius: 4px;" :disabled="rateShow">{{ $t('common.evaluation') }}</el-button>
                                </div>
                            </div>


                            <!-- 客户、客服 -->
                            <div v-else class="item" :class="{ sender: item.role == oprRoleName, receiver: item.role != oprRoleName }">
                                <div class="info-wrapper" :class="item.state">
                                    <div v-if="item.contentType==0" style="display: flex;" :class="{ quotesenderNewTwo: item.role == oprRoleName, quotereceiverNewTwo: item.role != oprRoleName }">
                                            <!-- 头像 -->
                                            <div class="avatar-wrapper" v-if="item.role!=oprRoleName&&item.contentType==0">
                                                <img class="kf-img" src="@/assets/im_server_avatar1.png" />
                                            </div>
                                            <!-- 1)文本类型 -->
                                            <div v-if="item.contentType==0" class="item-content common_chat_emoji-wrapper-global">
                                            <!-- <div style="position: relative;height: 100%;width: 100%;"> -->
                                                <img src="@/assets/fail.png" v-if="item.isSuccess==false" alt="" style="position: absolute;left: -20px;top: 45px;width: 16px;">
                                                <p class="time" >{{item.fromName}} {{ $ak.Utils.formatTimestamp(item.timestamp) }}</p>
                                                <div style="position: relative;display: inline-block;" :class="{ quotesenderNew: item.role == oprRoleName, quotereceiverNew: item.role != oprRoleName }">
                                                   <div class="text" v-html="getqqemojiEmoji(item.content)"></div>
                                                    <span  class="quote " :class="{ quotesender: item.role == oprRoleName, quotereceiver: item.role != oprRoleName }" @click="quote(item)">{{ $t('common.quote') }}</span>
                                                </div>
                                            </div>
                                    </div>
                                    <!-- <div v-if="item.contentType==5" style="display: flex;" :class="{ quotesenderNewTwo: item.role == oprRoleName, quotereceiverNewTwo: item.role != oprRoleName }">
                                            <div class="avatar-wrapper" v-if="item.role!=oprRoleName&&item.contentType==5">
                                                <img class="kf-img" src="@/assets/im_server_avatar1.png" />
                                            </div>
                                            <div v-if="item.contentType==5" class="item-content common_chat_emoji-wrapper-global">
                                                <img src="@/assets/fail.png" v-if="item.isSuccess==false" alt="" style="position: absolute;left: -20px;top: 45px;width: 16px;">
                                                <p class="time" >{{item.fromName}} {{ $ak.Utils.formatTimestamp(item.timestamp) }}</p>
                                                <div style="position: relative;display: inline-block;" :class="{ quotesenderNew: item.role == oprRoleName, quotereceiverNew: item.role != oprRoleName }">
                                                    <a :href="item.messageExpand.order_url" target="_blank"> <div class="text text_url" v-html="getqqemojiEmoji(item.content)"></div></a>
                                                    <span  class="quote " :class="{ quotesender: item.role == oprRoleName, quotereceiver: item.role != oprRoleName }" @click="quote(item)">{{ $t('common.quote') }}</span>
                                                </div>
                                            </div>
                                    </div> -->

                                    <!-- <div class="referenceContent" :class="{ quotesenderNews: item.role == oprRoleName, quotereceiverNews: item.role != oprRoleName }"  v-if="item.referenceContent&&Object.keys(item.referenceContent).length > 0&&item.referenceContent.content" v-html="item.referenceContent.content"></div> -->
                                    <div v-if="item.contentType==4" style="display: flex;" :class="{ quotesenderNewTwo: item.role == oprRoleName, quotereceiverNewTwo: item.role != oprRoleName }">
                                            <!-- 头像 -->
                                            <div class="avatar-wrapper" v-if="item.role!=oprRoleName&&item.contentType==4">
                                                <img class="kf-img" src="@/assets/im_server_avatar1.png" />
                                            </div>
                                            <!-- 1)文本类型 -->
                                            <div v-if="item.contentType==4" class="item-content common_chat_emoji-wrapper-global">
                                            <!-- <div style="position: relative;height: 100%;width: 100%;"> -->
                                                <img src="@/assets/fail.png" v-if="item.isSuccess==false" alt="" style="position: absolute;left: -20px;top: 45px;width: 16px;">
                                                <p class="time" >{{item.fromName}} {{ $ak.Utils.formatTimestamp(item.timestamp) }}</p>
                                                <div style="position: relative;display: inline-block;" :class="{ quotesenderNew: item.role == oprRoleName, quotereceiverNew: item.role != oprRoleName }">
                                                    <p class="" ><img class="img" style="max-width: 250px;" :src="item.content" @click="imgViewDialog_show(item)" /></p>
                                                    <span  class="quote " :class="{ quotesender: item.role == oprRoleName, quotereceiver: item.role != oprRoleName }" @click="quote(item)">{{ $t('common.quote') }}</span>
                                                </div>
                                            </div>
                                    </div>
                                 
                                    <div class="referenceContent common_chat_emoji-wrapper-global" :class="{ quotesenderNews: item.role == oprRoleName, quotereceiverNews: item.role != oprRoleName }"  v-if="item.referenceContent&&Object.keys(item.referenceContent).length > 0&&item.referenceContent.content&&item.referenceContent.contentType==0" v-html="getqqemojiEmoji(item.referenceContent.content)"></div>
                                    <div class="referenceContent" :class="{ quotesenderNews: item.role == oprRoleName, quotereceiverNews: item.role != oprRoleName }"  v-if="item.referenceContent&&Object.keys(item.referenceContent).length > 0&&item.referenceContent.content&&item.referenceContent.contentType==4" ><img :src="item.referenceContent.content" alt="" style="max-width: 100px;cursor: pointer;" @click="imgViewDialog_show(item)"></div>
                                    <!-- 3)文件类型 -->
                                    <div v-else-if="item.contentType=='file'" class="item-content">
                                        <div class="file">
                                            <i class="file-icon iconfont fa fa-file"></i>
                                            <div class="file-info">
                                                <p class="file-name">{{getFileName(item.fileName)}}</p>
                                                <div class="file-opr">
                                                    <div v-show="item.state=='success'">
                                                        <a class="file-download" :href="item.fileUrl" target="_blank" :download="item.fileUrl">{{ $t('common.download') }}</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 4)文本类型 -->
                                    <div v-if="item.contentType=='transformServer'" class="item-content common_chat_emoji-wrapper-global">
                                        <p class="text">
                                            {{ $t('common.noRobotConfig') }}
                                            <el-button type="text" @click="chatCallback('transformServer')">{{ $t('common.transferAgent') }}</el-button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 底部区域 -->
            <div class="common_chat-footer">
                <div>
                    <!-- 表情、文件选择等操作 -->
                    <div class="opr-wrapper" >
                        <common-chat-emoji class="item" ref="qqemoji" @select="qqemoji_selectFace"></common-chat-emoji>
                        <el-tooltip :content="$t('common.uploadImage')" placement="top" effect="dark">
                                <a class="item" href="javascript:void(0)" @click="fileUpload_click('file')">
                                <!-- <i class="iconfont fa fa-file-o"></i> -->
                                <img src="@/assets/picture.png" alt="">
                            </a>
                        </el-tooltip>
                        <form method="post" enctype="multipart/form-data">
                            <input type="file" name="uploadFile" id="common_chat_opr_fileUpload" style="display:none;position:absolute;left:0;top:0;width:0%;height:0%;opacity:0;" />
                        </form>
                    </div>
                    <!-- 聊天输入框 -->
                    <div class="input-wrapper">
                        <div
                            maxlength="500"
                            class="inputContent common_chat_emoji-wrapper-global"
                            id="common_chat_input"
                            contenteditable="true"
                            @paste.stop="inputContent_paste"
                            @drop="inputContent_drop"
                            @keydown="inputContent_keydown"
                            @mouseup="inputContent_mouseup"
                            @mouseleave="inputContent_mouseup"
                            :data-placeholder="$t('common.inputPlaceholder')"
                            @input="updateInputContent"
                        >
                        {{  chatInfoEn.inputContent}}
                         <!-- 默认占位符文字 -->
                         <span class="placeholder-text">{{ $t('common.inputPlaceholder') }}</span>
                    </div>
                    <!-- 发送按钮 -->
                    <div style="" class="common_chat_emoji-wrapper-global">
                        <span v-if="quoteInfo.content&&(quoteInfo.contentType==0||quoteInfo.contentType==5)" style="float: left; background: #E8E8E8;padding: 8px 12px;border-radius: 4px;font-size: 12px;color: #1F1F1F;width: 240px;display: block;padding: 5px;padding-left: 10px;box-sizing: border-box;"><span v-html="getqqemojiEmoji(quoteInfo.content)"></span> <i class="el-icon-circle-close circleClose" @click="quoteClear"></i></span>
                        <span v-if="quoteInfo.contentType==4" style="float: left; background: #E8E8E8;padding: 8px 12px;border-radius: 4px;font-size: 12px;color: #1F1F1F;width: 240px;display: block;padding: 5px;padding-left: 10px;box-sizing: border-box;"><span>{{ $t('common.image') }}</span> <i class="el-icon-circle-close circleClose" @click="quoteClear"></i></span>
                        <el-button style="float: right;" type="primary" size="small" class="send-btn"  :class="chatInfoEn.state" @click="sendText()" :disabled="chatInfoEn.inputContent.length==0 || !socketConnected">{{ $t('common.send') }}</el-button>
                    </div>
                    </div>

                </div>
                <!-- 离线 -->
                <div  class="off-wrapper" v-show="rateWord==true||assignFail==true||kickFail==true||retryCountShow==true||csUserIdShow==true">
                    <!-- <span class="content">会话已经结束</span> -->
                    <div class="btn-wrapper" >
                        <div @click="continueToConsult">
                            <img src="@/assets/chat.png" alt="">
                            <p>{{ $t('common.continueConsult') }}</p>
                        </div>
                        <div @click="closeChat">
                            <img src="@/assets/close.png" alt="">
                            <p>{{ $t('common.close') }}</p>
                        </div>
                    </div>
                </div>
            </div>
          <!--<span class="tip">由云库提供技术服务</span>-->
        </div>
        <!-- 图片查看dialog -->
        <el-dialog title :visible.sync="imgViewDialogVisible" class="imgView-dialog" :modal="false">
            <!-- <div class="header">
                <i class="iconfont fa fa-remove" @click="imgViewDialog_close"></i>
            </div> -->
            <div class="main">
                <img class="img" :src="imgViewDialog_imgSrc" />
            </div>
        </el-dialog>
    </div>
</template>

<script>

import common_chat_emoji from './common_chat_emoji.vue';
import {uploadImg} from '@/common/imCilent.js'

export default {
    components: {
        commonChatEmoji: common_chat_emoji,
    },
    props: {
        chatInfoEn: {
            required: true,
            type: Object,
            default: {
                inputContent: '', // 本次输入框的消息内容
                msgList: [], // 消息集合
            },
        },
        page:{
            required: true,
            type: Number,
            default: 0
        },
        historyDataList:{
            required: true,
            type: Array,
            default: []
        },
        total:{
            required: true,
            type: Number,
            default: 0
        },
        oprRoleName: {
            required: true,
            type: String,
            default: '',
        }, // 操作者名称；e.g. server:服务端、client:客服端
        assignFail:{
            required: true,
            type: Boolean,
            default: false,
        },
        rateWord:{
            required: true,
            type: Boolean,
            default: false
        },
        rateShow:{
            required: true,
            type: Boolean,
            default: false
        },
        kickFail:{
            required: true,
            type: Boolean,
            default: false
        },
        retryCountShow:{
            required: true,
            type: Boolean,
            default: false
        },
        csUserIdShow:{
            required: true,
            type: Boolean,
            default: false
        },
        dataIsRated:{
            required: true,
            type: Object,
        },
        socketConnected: {
            type: Boolean,
            default: false
        }

    },
    data() {
        return {
            inputContent_setTimeout: null, // 输入文字时在输入结束才修改具体内容
            selectionRange: null, // 输入框选中的区域
            shortcutMsgList: [], // 聊天区域的快捷回复列表
            imgViewDialogVisible: false, // 图片查看dialog的显示
            imgViewDialog_imgSrc: '', // 图片查看dialog的图片地址
            chatLoaded: false, // chat是否已加载完毕
            scrollTopBeforeLoad: 0, // 记录加载前的滚动位置
            quoteInfo:{}  //引用的消息
        };
    },
    computed: {},
    watch: {
        dataIsRated: {
            handler(newValue, oldValue) {
              //console.log("dataIsRated",newValue)
              //console.log("dataIsRatedold",oldValue)
              this.historyDataList.forEach(item => {
                    if (item.messageExpand && item.messageExpand.imMessageSessionId === newValue.messageExpand.imMessageSessionId) {
                        // 如果找到匹配的消息，修改该消息的 IsRated 为 true
                        item.messageExpand.evaluationStatus = 1;
                    }
                    });
            },
            deep: true
        },
    },
    created(){

    },
    mounted() {
        //console.log(this.dataIsRated)
        this.$nextTick(function () {
            this.$data.chatLoaded = true;
            this.init();


        });


    },
    methods: {
        updateInputContent() {
        var content = document.getElementById('common_chat_input').textContent; // 获取 contenteditable 内容
        this.chatInfoEn.inputContent = content; // 更新 inputContent
    },

        // 触发父组件加载更多历史消息
        loadMoreMessages() {
            this.isLoading = true; // 开始加载

             // 记录当前的滚动位置
            const scrollHeightBeforeLoad = this.$refs.common_chat_main.scrollHeight;
            //console.log("scrollHeightBeforeLoad", scrollHeightBeforeLoad);
            // 发射 loadMore 事件，告知父组件加载更多消息
            // 在数据加载完成后，恢复滚动位置
            this.$emit('loadMore', (success) => {
                //console.log("loadMore result", success)
                this.$nextTick(() => {
                    //console.log("scrollHeightAfterLoad", this.$refs.common_chat_main.scrollHeight);
                    // 获取新消息列表后，恢复滚动位置
                    this.$refs.common_chat_main.scrollTop = this.$refs.common_chat_main.scrollHeight - scrollHeightBeforeLoad;
                });
            });

        },


        /**
         * 初始化
         * @param {Object} opts 可选对象
         */
        init: function (opts) {
            var self = this;
            // 初始化状态
            document.getElementById('common_chat_input').innerHTML = '';
            self.$refs.qqemoji.$data.faceHidden = true;

            // 在线状态
            if (this.chatInfoEn.state == 'on') {
                // 1.显示在输入框的内容
                setTimeout(function () {
                    // 未断开获取焦点
                    // document.getElementById('common_chat_input').focus();
                    self.setInputContentSelectRange();
                    // 设置之前保存的输入框内容
                    if (self.chatInfoEn.inputContent) {
                        self.setInputDiv(self.chatInfoEn.inputContent);
                    }
                }, 200);
            } else {
                document.getElementById('common_chat_input').blur();
            }

            // 2.滚动到底部
            this.$nextTick(function () {
                self.$refs.common_chat_main.scrollTop = self.$refs.common_chat_main.scrollHeight;
                // document.getElementById('common_chat_input').focus();
            });
        },

        /**
         * 发送文本
         */
        sendText: function () {
            var self = this;
            if (!self.socketConnected) return;
            if (self.chatInfoEn.inputContent.length == '') {
                return;
            }
            var msgContent = self.chatInfoEn.inputContent;
            document.getElementById('common_chat_input').innerHTML = '';
            self.setInputContentByDiv();
            this.sendMsg({
                contentType: 0,
                content: msgContent,
                referenceContent:self.quoteInfo
            });
            this.quoteInfo={}
        },

        /**
         * 设置输入内容
         * 根据input输入框innerHTML转换为纯文本
         */
        setInputContentByDiv: function () {
            var self = this;
            var htmlStr = document.getElementById('common_chat_input').innerHTML;

            // 1.转换表情为纯文本：<img textanme="[笑]"/> => [笑]
            var tmpInputContent = htmlStr.replace(/<img .+?text=\"(.+?)\".+?>/g, '[$1]').replace(/<.+?>/g, '');

            // 2.设置最长长度
            if (tmpInputContent.length > 500) {
                document.getElementById('common_chat_input').innerHTML = '';
                var value = tmpInputContent.substr(0, 499).replace(/\[(.+?)\]/g, function (item, value) {
                    return self.$refs.qqemoji.getImgByFaceName(value);
                });
                this.setInputDiv(value);
            }

            // 3.修改store
            this.chatInfoEn.inputContent = tmpInputContent;
            if (!tmpInputContent) {
            this.chatInfoEn.inputContent = '';
        }
        },

        /**
         * 设置input输入框内容
         * @param {String} vlaue 设置的值
         */
        setInputDiv: function (value) {
            if (this.$data.selectionRange == null) {
                document.getElementById('common_chat_input').focus();
                return;
            }
            // 1.设置selectionRange
            if (window.getSelection) {
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(this.$data.selectionRange);
            } else {
                this.$data.selectionRange && this.$data.selectionRange.select();
            }

            // 2.表情转换为img
            value = this.getqqemojiEmoji(value);

            // 3.聊天框中是否选中了文本，若选中文本将被替换成输入内容
            if (window.getSelection) {
                var sel, range;
                // IE9 and non-IE
                sel = window.getSelection();
                if (sel.getRangeAt && sel.rangeCount) {
                    // 1)删除选中的文本(内容)
                    range = sel.getRangeAt(0); // 获取鼠标选中的文本区域
                    range.deleteContents(); // 删除选中的文本

                    // 2)创建以输入内容为内容的DocumentFragment
                    var elemnet;
                    if (range.createContextualFragment) {
                        elemnet = range.createContextualFragment(value);
                    } else {
                        // 以下代码等同createContextualFragment
                        // 创建一个DocumentFragment
                        elemnet = document.createDocumentFragment();

                        var divEl = document.createElement('div');
                        divEl.innerHTML = value;
                        // divEl下的元素，依次插入到DocumentFragment
                        for (let i = 0, len = divEl.children.length; i < len; i++) {
                            elemnet.appendChild(divEl.firstChild);
                        }
                    }
                    // 3)选中文本的位置替换为新输入的内容，并把光标定位到新内容后方
                    var lastNode = elemnet.lastChild;
                    range.insertNode(elemnet);
                    range.setStartAfter(lastNode);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
            } else if (document.selection && document.selection.type != 'Control') {
                // IE < 9
                document.selection.createRange().pasteHTML(imgStr);
            }

            // 4.修改inputContent
            this.setInputContentByDiv();
        },

        /**
         * 转换为QQ表情
         */
        getqqemojiEmoji: function (value) {
            if (value == undefined) {
                return;
            }
            var self = this;
            let rs = value.replace(/\[(.+?)\]/g, function (item, value) {
                return self.$refs.qqemoji.getImgByFaceName(value);
            });
            // console.log(rs)
            return rs;
        },

        /**
         * 设置input输入框的选择焦点
         */
        setInputContentSelectRange: function () {
            if (window.getSelection && window.getSelection().rangeCount > 0) {
                var selectRange = window.getSelection().getRangeAt(0);
                if (
                    selectRange.commonAncestorContainer.nodeName == '#text' &&
                    selectRange.commonAncestorContainer.parentElement &&
                    selectRange.commonAncestorContainer.parentElement.id == 'common_chat_input'
                ) {
                    // 选中了输入框内的文本
                    this.$data.selectionRange = selectRange;
                } else if (selectRange.commonAncestorContainer.id == 'common_chat_input') {
                    // 选中了输入框
                    this.$data.selectionRange = selectRange;
                }
            }
        },

        /**
         * 输入框的mouseup
         */
        inputContent_mouseup: function (e) {
            this.setInputContentSelectRange();
        },

        /**
         * 输入框的keydown
         */
        inputContent_keydown: function (e) {
            // keyup触发时，绑定的数据还没有被变更，需要进行延后访问
            clearTimeout(this.$data.inputContent_setTimeout);
            this.$data.inputContent_setTimeout = setTimeout(() => {
                this.setInputContentByDiv();

                // 若按了回车，直接发送
                if (e.keyCode == 13) {
                    this.sendText();
                }
                this.setInputContentSelectRange();
            }, 1);
        },

        /**
         * 输入框的粘贴
         */
        inputContent_paste: function (e) {
            var self = this;
            var isImage = false;
            if (e.clipboardData && e.clipboardData.items.length > 0) {
                // 1.上传图片
                for (var i = 0; i < e.clipboardData.items.length; i++) {
                    var item = e.clipboardData.items[i];
                    if (item.kind == 'file' && item.type.indexOf('image') >= 0) {
                        // 粘贴板为图片类型
                        var file = item.getAsFile();
                        let formData = new FormData();
                        formData.append('file', file);
                        uploadImg(formData).then((res) => {
                        document.getElementById('common_chat_opr_fileUpload').value = '';
                            this.sendMsg({
                                contentType: 4,
                                // fileName: fileName,
                                fileUrl: res.data.url,
                                state: 'success',
                                referenceContent:this.quoteInfo
                            });
                            this.quoteInfo={}
                    })

                        // this.$http.uploadFile({
                        //     url: '/upload',
                        //     params: formData,
                        //     successCallback: (rs) => {
                        //         document.getElementById('common_chat_opr_fileUpload').value = '';
                        //         this.sendMsg({
                        //             contentType: 'image',
                        //             fileName: rs.fileName,
                        //             fileUrl: rs.fileUrl,
                        //             state: 'success',
                        //         });
                        //     },
                        // });
                        isImage = true;
                    }
                }

                // 2.非图片，粘贴纯文本
                if (!isImage) {
                    var str = e.clipboardData.getData('text/plain');
                    // 转化为纯文字
                    var span = document.createElement('span');
                    span.innerHTML = str;
                    var txt = span.innerText;
                    this.setInputDiv(txt.replace(/\n/g, '').replace(/\r/g, '').replace(/</g, '&lt;').replace(/>/g, '&gt;'));
                }
            }
            e.stopPropagation();
            e.preventDefault();
        },

        /**
         * 文件上传_点击
         */
        fileUpload_click: function (fileType) {
            document.getElementById('common_chat_opr_fileUpload').onchange = this.fileUpload_change;
            document.getElementById('common_chat_opr_fileUpload').click();
        },

        /**
         * 文件上传_选中文件
         */
        fileUpload_change: function (e) {
            var fileNameIndex = document.getElementById('common_chat_opr_fileUpload').value.lastIndexOf('\\') + 1;
            var fileName = document.getElementById('common_chat_opr_fileUpload').value.substr(fileNameIndex);
            var extend = fileName.substring(fileName.lastIndexOf('.') + 1);
            // 1.判断有效
            // 1)大小
            if (document.getElementById('common_chat_opr_fileUpload').files[0].size >= 1000 * 1000 * 10) {
                this.$ak.Msg.toast(this.$t('common.fileSizeLimit'), 'error');
                document.getElementById('common_chat_opr_fileUpload').value = '';
                return false;
            }

            // 2.文件上传
            let formData = new FormData();
            formData.append('file', document.getElementById('common_chat_opr_fileUpload').files[0]);
                uploadImg(formData).then((res) => {
                document.getElementById('common_chat_opr_fileUpload').value = '';
                    this.sendMsg({
                        // contentType: ['png', 'jpg', 'jpeg', 'gif', 'bmp'].indexOf(extend) >= 0 ? 'image' : 'file',
                        contentType: 4,
                        fileName: fileName,
                        fileUrl: res.data.url,
                        state: 'success',
                        referenceContent:this.quoteInfo
                    });
                    this.quoteInfo={}

            })
            // this.$http.uploadFile({
            //     url: '/server/upload/file',
            //     params: formData,
            //     successCallback: (rs) => {
            //         document.getElementById('common_chat_opr_fileUpload').value = '';
            //         this.sendMsg({
            //             contentType: ['png', 'jpg', 'jpeg', 'gif', 'bmp'].indexOf(extend) >= 0 ? 'image' : 'file',
            //             fileName: fileName,
            //             fileUrl: rs.fileUrl,
            //             state: 'success',
            //         });
            //     },
            // });
        },

        /**
         * qqemoji选中表情
         */
        qqemoji_selectFace: function (rs) {
            var imgStr = rs.imgStr;
            this.setInputDiv(imgStr);
        },

        /**
         * 转换文件名，若文件名称超过9个字符，将进行截取处理
         * @param {String} fileName 文件名称
         */
        getFileName: function (fileName) {
            if (!fileName) {
                return;
            }
            var name = fileName.substring(0, fileName.lastIndexOf('.'));
            var extend = fileName.substring(fileName.lastIndexOf('.') + 1);
            if (name.length > 9) {
                name = name.substring(0, 3) + '...' + name.substring(name.length - 3);
            }
            return name + '.' + extend;
        },

        /**
         * 图片查看dialog_显示
         */
        imgViewDialog_show: function (item) {
            // this.$data.imgViewDialogVisible = true;
            // this.$data.imgViewDialog_imgSrc = item.fileUrl;
            if(item.referenceContent&&Object.keys(item.referenceContent).length > 0&&item.referenceContent.content){
                window.open('/image??fileUrl='+item.referenceContent.content)
            }else{
                window.open('/image??fileUrl='+item.content)
            }
           
        },

        /**
         * 图片查看dialog_显示
         */
        imgViewDialog_close: function () {
            this.$data.imgViewDialogVisible = false;
            var self = this;
            setTimeout(function () {
                self.$data.imgViewDialog_imgSrc = '';
            }, 100);
        },

        /**
         * 输入框的拖拽
         */
        inputContent_drop: function (e) {
            var self = this;
            setTimeout(function () {
                self.setInputContentByDiv();
            }, 100);
        },

        /**
         * 发送消息，e.g. 文本、图片、文件
         * @param {Object} msg 消息对象
         */
        sendMsg: function (msg) {
            if (!this.socketConnected) return;
            var self = this;
            // 1.传递
            this.$emit('sendMsg', {
                msg: msg,
                successCallbcak: function () {
                    document.getElementById('common_chat_input').focus();
                    self.goEnd();
                },
            });
        },

        /**
         * 传递回调
         */
        chatCallback: function (emitType, data) {
            this.$emit('chatCallback', {
                eventType: emitType,
                data: data,
            });
        },

        /**
         * 聊天记录滚动到底部
         */
        goEnd: function () {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.common_chat_main.scrollTop = this.$refs.common_chat_main.scrollHeight;
                }, 100);
            });
        },
        // 继续咨询
        continueToConsult(){
            this.$emit('continueToConsult')
        },
        // 关闭
        closeChat(){
            this.$emit('closeChatIm')
        },
        // 引用
        quote(item){
            this.quoteInfo = item;
            console.log(this.quoteInfo)
            document.getElementById('common_chat_input').focus();
        },
        // 关闭
        quoteClear(){
            this.quoteInfo = {};
            document.getElementById('common_chat_input').focus();
        },
        // 评价按钮操作
        sendRate(item,num){
            let data = {
                item:item,
                num:num
            }
            this.$emit('sendRate',data)
        },

    },
};
</script>
<style lang="less">
.common_chat-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    font-size: 12px;
    float: left;
    border: 0px;
    .common_chat-inner {
        width: 100%;
        height: 100%;
        // background: linear-gradient(180deg, #f7f7f7 0, #f3f3f3 100%);
        background: #fff;
        .common_chat-main {
            position: relative;
            height: calc(~'100% - 190px');
            overflow-y: auto;
            overflow-x: hidden;
            background: linear-gradient(180deg, #f7f7f7 0, #f3f3f3 100%);
            .common_chat-main-header {
                padding-top: 14px;
                text-align: center;
                .el-button {
                    padding: 0px;
                    font-size: 12px;
                    color: #8d8d8d;
                }
            }
            .common_chat-main-content {
                position: absolute;
                width: 100%;
                height: 100%;
                & > .inner {
                    padding-bottom: 20px;
                    .item {
                        clear: both;
                        overflow: hidden;
                    }
                    .sys {
                        color: #b0b0b0;
                        font-size: 12px;
                        text-align: center;
                        .text-content {
                            // padding-top: 20px;
                            line-height: 25px;
                        }
                        .myd-content {
                            .desc {
                                margin-top: 18px;
                            }
                            .text {
                                color: #3e3e3e;
                                margin-top: 12px;
                            }
                            .remark {
                                margin-top: 10px;
                            }
                        }
                    }
                    .receiver,
                    .sender {
                        // margin-top: 10px;
                        font-size: 12px;
                        .avatar-wrapper {
                            float: left;
                            .kf-img {
                                width: 30px;
                                height: 30px;
                                margin-top: 10px;
                            }
                        }
                        .info-wrapper {
                            position: relative;
                            text-align: left;
                            font-size: 12px;
                            // display: flex;
                            .item-content {
                                position: relative;
                                max-width: 260px;
                                height: 100%;
                                color: #3e3e3e;
                                font-size: 13px;
                                border-radius: 3px;

                                .text {
                                    // line-height: 1.8;
                                    // white-space: normal;
                                    // word-wrap: break-word;
                                    // word-break: break-all;
                                    // padding: 5px 8px;
                                    // margin-left: 10px;
                                    // // margin-top: 10px;
                                    // margin-bottom: 16px;
                                    // background-color: #fff !important;
                                    // display: inline-block;
                                    // padding: 10px 12px;
                                    // float: left;
                                    // word-break: break-all;
                                    // word-wrap: break-word;
                                    // color: #1f1f1f;
                                    // border-radius: 10px 4px 10px 10px;
                                    // position: relative;
                                    // max-width: 100%;
                                    // font-size: 14px;
                                    // line-height: 1.3
                                    // margin-left: 10px;
                                    // margin-bottom: 16px;
                                    // margin-right: 10px;
                                    // margin-top: 6px;
                                    background-color: #feffff;
                                    display: inline-block;
                                    padding: 10px 12px;
                                    float: left;
                                    word-break: break-all;
                                    word-wrap: break-word;
                                    color: #1f1f1f;
                                    border-radius: 4px 10px 10px 10px;
                                    max-width: 100%;
                                    box-sizing: border-box;
                                    position: relative;
                                       font-size: 14px;
                                    line-height: 1.3;
                                    margin:0;

                                }
                                .qqemoji {
                                    width: 24px;
                                    height: 24px;
                                }
                                .img {
                                    max-width: 320px;
                                    max-height: 240px;
                                    white-space: normal;
                                    word-wrap: break-word;
                                    word-break: break-all;
                                    padding: 5px;
                                    cursor: pointer;
                                }
                                .file {
                                    width: 220px;
                                    padding: 10px 8px;
                                    margin: 3px;
                                    overflow: hidden;
                                    background: #fff;
                                    border-radius: 5px;
                                    .el-button {
                                        padding: 0px;
                                        font-size: 12px;
                                    }
                                    .file-info {
                                        float: left;
                                        padding: 0px 8px;
                                        .file-name {
                                            width: 160px;
                                            display: inline-block;
                                            color: #333333;
                                            white-space: nowrap;
                                            text-overflow: ellipsis;
                                            overflow: hidden;
                                            line-height: 1.3;
                                        }
                                    }
                                    .file-opr {
                                        margin-top: 8px;
                                    }
                                    .file-icon {
                                        float: left;
                                        color: #663399;
                                        font-size: 40px;
                                    }
                                    .file-download {
                                        color: #00a8d7;
                                        cursor: pointer;
                                        text-decoration: blink;
                                    }
                                }
                                .preInput {
                                    position: relative;
                                    color: #8d8d8d;
                                    img {
                                        height: 15px;
                                        position: relative;
                                        top: 3px;
                                    }
                                }
                                .issueList {
                                    width: 250px;
                                    padding: 10px;
                                    .title {
                                        position: relative;
                                        .content {
                                            position: absolute;
                                            margin-top: -1px;
                                            margin-left: 6px;
                                        }
                                    }
                                    .el-collapse-item__wrap {
                                        background: transparent;
                                    }
                                    .el-collapse {
                                        border: 0px;
                                        margin-top: 8px;
                                        margin-bottom: -8px;
                                        .el-collapse-item__header {
                                            font-size: 13px;
                                            background: transparent;
                                            color: #f7455d;
                                            padding-left: 5px;
                                        }
                                        .el-collapse-item__wrap {
                                            .el-collapse-item__content {
                                                font-size: 12px;
                                                color: #3e3e3e;
                                                padding-left: 5px;
                                            }
                                        }
                                    }
                                }
                                .issueExtend {
                                    width: 250px;
                                    padding: 10px 10px 0px;
                                    .main {
                                        border-top: 1px solid #eeeff0;
                                        margin-top: 10px;
                                        padding-top: 10px;
                                        p {
                                            margin-bottom: 5px;
                                        }
                                        .el-button {
                                            font-size: 12px;
                                            color: #f7455d;
                                        }
                                    }
                                }
                                .issueResult {
                                    width: 250px;
                                    .main {
                                        padding: 10px;
                                    }
                                    .footer {
                                        border-top: 1px solid #eeeff0;
                                        height: 30px;
                                        .btn {
                                            width: 60px;
                                            margin: 0px 30px;
                                            padding: 6px 0px;
                                            display: inline-block;
                                            text-align: center;
                                            font-size: 10px;
                                            color: #8d8d8d;
                                            cursor: pointer;
                                            position: relative;
                                            &:first-child::after {
                                                top: 4px;
                                                right: -30px;
                                                width: 1px;
                                                height: 80%;
                                                content: '';
                                                position: absolute;
                                                background-color: #eeeff0;
                                                z-index: 0;
                                            }
                                        }
                                        .iconfont {
                                            font-size: 10px;
                                            margin-right: 5px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .item.receiver {
                        margin-left: 10px;
                        margin-bottom: 20px;
                        .time {
                            justify-content: flex-start;
                        }
                        .avatar-wrapper {
                            margin-right: 5px;
                        }
                        .info-wrapper {
                            .item-content {
                                // float: left;
                                // color: #000000;
                                // background-color: #f9fbfc;
                                // border: 1px solid #ccc;
                                // &::before {
                                //     position: absolute;
                                //     top: -1px;
                                //     left: -10px;
                                //     width: 0px;
                                //     height: 0px;
                                //     content: '';
                                //     border-top: 0px;
                                //     border-right: 10px solid #ccc;
                                //     border-bottom: 5px solid transparent;
                                //     border-left: 0px;
                                // }
                            }
                        }
                    }

                    .item.sender {
                        margin-right: 10px;
                        margin-bottom: 20px;
                        .time {
                            justify-content:flex-end;
                        }
                        .avatar-wrapper {
                            float: right;
                            margin-left: 15px;
                        }
                        .info-wrapper {
                            float: right;
                            .item-content {
                                // float: right;
                                // // background: #0095ff;
                                // // border: 1px solid #0095ff;
                                // // color: #ffffff;
                                // color: #333;
                                // background: #fff;
                                // /* position: absolute; */
                                // right: 40px;
                                // top: 15px;
                                .text {
                                    // margin-left: 10px;s
                                    // margin-top: 10px;
                                    // margin-bottom: 16px;
                                    background-color: #fff !important;
                                    display: inline-block;
                                    padding: 10px 12px;
                                    float: right;
                                    word-break: break-all;
                                    word-wrap: break-word;
                                    color: #1f1f1f;
                                    border-radius: 10px 4px 10px 10px;
                                    position: relative;
                                    max-width: 100%;
                                    font-size: 14px;
                                    line-height: 1.3;
                                    margin: 0;
                                }
                                .text_url {
                                            &:hover{
                                                color: #2295FF !important;
                                            }
                                    }

                                // &::before {
                                //     position: absolute;
                                //     top: -1px;
                                //     right: -10px;
                                //     width: 0px;
                                //     height: 0px;
                                //     content: '';
                                //     border-top: 0px;
                                //     border-right: 0px;
                                //     border-bottom: 5px solid transparent;
                                //     border-left: 10px solid #0095ff;
                                // }
                            }
                        }
                    }
                }
            }
        }
        .common_chat-footer {
            position: relative;
            width: 100%;
            height: 190px;
            // border-top: 1px solid #ccc;
            // background-color: #fff;
            .opr-wrapper {
                height: 20px;
                padding: 10px;
                text-align: left;
                & > .item {
                    margin-right: 12px;
                    float: left;
                    font-weight: normal;
                    text-decoration: blink;
                    & > .iconfont {
                        color: #aaa;
                        font-size: 20px;
                    }
                }
            }
            .input-wrapper {
                position: relative;
                padding: 0 10px 0 10px;
                .inputContent {
                    width: 99%;
                    padding: 2px;
                    // height: 85px;
                    height: 100px;
                    resize: none;
                    overflow: auto;
                    line-height: 1.5;
                    outline: 0px solid transparent;
                }
                .shortcutPopover-wrapper {
                    position: absolute;
                    top: 30px;
                    left: 10px;
                    width: 440px;
                    max-height: 80px;
                    padding: 4px;
                    font-size: 12px;
                    overflow-y: auto;
                    border: 1px solid #9b9aab;
                    border-radius: 3px;
                    background-color: #fff;
                    cursor: pointer;
                    p {
                        padding: 4px;
                        &.selected {
                            background-color: #ded1cc;
                        }
                        .key {
                            display: inline-block;
                            width: 50px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                        .content {
                            display: inline-block;
                            width: 350px;
                            margin-left: 10px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                        .highlight {
                            color: #00a8d7;
                        }
                    }
                }
                .tips {
                    position: absolute;
                    top: 7px;
                    left: 20px;
                    width: auto;
                    color: #8d8d8d;
                }
            }
            .send-btn {
                float: right;
                margin-right: 16px;
                border-radius: 10px;
                height: 28px;
                /* line-height: 9px; */
                width: 50px;
                padding: 0;

                &.off,
                &.end {
                    background-color: #ccc;
                    border-color: #ccc;
                }
            }
            .off-wrapper {
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
                // background-color: rgba(255, 255, 255, 0.6);
                background-color: #E6E6E6;
                font-size: 14px;
                .btn-wrapper {
                    // position: absolute;
                    // top: 50%;
                    /* left: 50%; */
                    display: flex;
                    justify-content: center;
                    font-size: 16px;
                    padding-top: 45px;
                    div {
                        cursor: pointer;
                        text-align: center;
                        p {margin-top: 6px;}
                    }
                    >div:nth-child(2) {
                        margin-left: 50px;
                    }
                }
                .content {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
    }
}
.imgView-dialog {
    background: #00000080;
    height: 100%;
    .el-dialog {
        max-width: 75%;
        position: relative;
        background: transparent;
        box-shadow: none;
        margin: 0 auto;
        .el-dialog__header {
            display: none;
        }
        .el-dialog__body {
            padding: 0px;
            text-align: center;
            position: relative;
            .header {
                text-align: right;
                position: relative;
                height: 0px;
                .fa-remove {
                    font-size: 32px;
                    color: white;
                    position: relative;
                    right: -50px;
                    top: -30px;
                    cursor: pointer;
                }
            }
            .main {
                .img {
                    max-width: 100%;
                    max-height: 100%;
                    height: 100%;
                }
            }
        }
    }
}
.tip {
    position: fixed;
    bottom: 0;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background-color: #fafafa;
    font-weight: 400;
    color: #9e9e9e;
    width: 355px;
}
.inputContent[data-placeholder]:empty::before {
    content: attr(data-placeholder);
    color: #999; /* 灰色文字 */
    pointer-events: none; /* 不可点击 */
}
.time {
    font-size: 12px;
    color: #9e9e9e;
    display: flex;
    margin-bottom: 5px;
}
.quote {
    position: absolute;
    bottom: 0;
    right: -30px;
    opacity: 0;
    font-size: 12px;
    color: #2295FF;
    cursor: pointer;
    transition: opacity 0.3s ease;

}
.quotesender {
    left: -30px;
    bottom: 0;
}
.item-content:hover .quote {
    opacity: 1;
}
.referenceContent {
    float: right;
    margin: 0;
    margin-top: 5px;
    background: #E8E8E8;
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 12px;
    color: #797979;
    word-wrap: break-word;
    word-break: break-all;
    max-width: 260px;
    // min-width: 100%;
}
.circleClose {
    font-size: 14px;
    float: right;
    cursor: pointer;
}
.quotesenderNew {
   float: right;
}
.quotereceiverNew{
    float: left;
}
.quotesenderNews {
   float: right;
}
.quotereceiverNews{
    float: left;
    margin-left: 35px;
}
.quotesenderNewTwo {
    justify-content: flex-end;

}
.quotereceiverNewTwo {
    justify-content: flex-start;
}
.evaluation {
    height: auto;
    text-align: center;
    background-color: #ccc;
    padding: 10px 0;
    font-size: 12px;
    margin: 0 15px;
    .evaluation_title{
        // margin-bottom: 6px;
    }
    .evaluation_easy {

    }
    .evaluation_btn_easy {
        background: #2295FF;
        border: 1px solid #2295FF;
        cursor: pointer;
        color: #fff;
    }
   
}

</style>

